/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Kb_Side_3Inputs */

const en_signin_kb_side_3 = /** @type {(inputs: Signin_Kb_Side_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team chat, issues, and agent output live in one searchable history.`)
};

const id_signin_kb_side_3 = /** @type {(inputs: Signin_Kb_Side_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat tim, issue, dan hasil kerja agen ada di satu riwayat yang bisa dicari.`)
};

/**
* | output |
* | --- |
* | "Team chat, issues, and agent output live in one searchable history." |
*
* @param {Signin_Kb_Side_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_kb_side_3 = /** @type {((inputs?: Signin_Kb_Side_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Kb_Side_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_kb_side_3(inputs)
	return en_signin_kb_side_3(inputs)
});